import React from "react";
import {ButtonMock} from ".";
import {HtmlDisplay} from "../Display";
import {notificationSuffix} from "./inputConstants";

interface NotificationProps {
	error?: string;
	name: string;
	label?: string;
}

export const Notification: React.FC<NotificationProps> = ({
								 error,
								 name,
							}: NotificationProps) => {
	return (
		<div className="notification" id={`${name}${notificationSuffix}`} role="alert">
			{
				error &&
				<>
					<ButtonMock
						className={`notification__button`}
						label={error}
						hideLabel
						name={`${name}${notificationSuffix}_button`}
					/>
					<HtmlDisplay className={"notification__message"} html={error} />
				</>
			}
		</div>
	);
};
